export const stories = ({dispatch}) => next => (action) => {
    next(action);
}
